import type { ReportDateRangeFilter } from 'src/api/generated';
import { ReportDateRangePicker } from './report-date-range-picker';

/**
 * Preset and custom range selector for report widgets.
 */
export const ReportDateRangeSelector: React.FC<{
  value: ReportDateRangeFilter;
  onChange: (value: ReportDateRangeFilter) => void;
  errorMessage?: string | null;
}> = ({ value, onChange, errorMessage = null }) => {
  return (
    <ReportDateRangePicker
      value={value}
      onApply={onChange}
      errorMessage={errorMessage}
      className="w-full"
      triggerClassName="w-full sm:w-full"
    />
  );
};
